import {RedirectService} from '../services/redirect.service';
import {Directive, HostListener, Input} from '@angular/core';

@Directive({
  selector: ':not(a):not(area)[externalRedirect]'
})
export class ExternalRedirectDirective {

  constructor(readonly redirect: RedirectService) {
  }

  @Input('externalRedirect') url: string;

  @HostListener('click') onClick() {
    if (!this.url) {
      return true;
    }
    this.redirect.jump(this.url);
    return false;
  }
}
